import React, { useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import ConnectFA from '../ConnectFA/ConnectFA';
import SendResultsButton from '../SendResultsButton/SendResultsButton';
import DownloadButton from '../DownloadButton/DownloadButton';
import '../../pages/Results/Results.scss';
import { LocaleContext } from '../../contexts';
import getText from '../../assets/locale/locale';
import './DownloadSendConnect.scss';

const DownloadSendConnect = ({
  downloadingPdf,
  setDownloadingPdf,
  showFindFa,
  showCaFindFa,
  showSendToFa,
  sendingPdfToFa,
  setSendingPdfToFa,
  setResultsSentToFa,
  sendResultsButtonDisabled,
  resultsToSendToDelegator,
  setNotificationContent,
  setNotificationOpen,
  query,
  sessionId,
  coldContactData,
  setColdContactData,
  faInfo,
  contactName,
  userComments,
  setUserComments,
}) => {
  const locId = useContext(LocaleContext);
  const topOfResultsPage = useRef();

  return (
    <>
      <div className="results-left-wrapper">
        <div className="results-left">
          <div className="pass-message" data-testid="results-greeting">
            <h1 id="heading-no-focus" ref={topOfResultsPage} tabIndex="-1">
              {getText(locId, 'Results', 'heading', 'ResultsGreeting')}
            </h1>
            <p>
              {getText(
                locId,
                'Results',
                'greetingParagraphPart1',
                'ResultsGreeting'
              )}
              <a
                href={getText(locId, 'Results', 'linkUrl', 'ResultsGreeting')}
                target="_blank"
                rel="noopener noreferrer"
                className="link"
              >
                {getText(locId, 'Results', 'linkText', 'ResultsGreeting')}
              </a>
              {getText(
                locId,
                'Results',
                'greetingParagraphPart2',
                'ResultsGreeting'
              )}
            </p>
            <div className="final-actions top-buttons">
              <DownloadButton
                resultsToSendToDelegator={resultsToSendToDelegator}
                downloadingPdf={downloadingPdf}
                setDownloadingPdf={setDownloadingPdf}
                setNotificationContent={setNotificationContent}
                setNotificationOpen={setNotificationOpen}
                coldContactData={coldContactData}
                userComments={userComments}
              />
              {showSendToFa && (
                <SendResultsButton
                  sendingPdfToFa={sendingPdfToFa}
                  setSendingPdfToFa={setSendingPdfToFa}
                  setResultsSentToFa={setResultsSentToFa}
                  sendResultsButtonDisabled={sendResultsButtonDisabled}
                  resultsToSendToDelegator={resultsToSendToDelegator}
                  setNotificationContent={setNotificationContent}
                  setNotificationOpen={setNotificationOpen}
                  query={query}
                  sessionId={sessionId}
                  coldContactData={coldContactData}
                  setColdContactData={setColdContactData}
                  faInfo={faInfo}
                  contactName={contactName}
                  userComments={userComments}
                  setUserComments={setUserComments}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="results-right">
        <div className="results-image" role="img" aria-label="" />
        {showFindFa && showCaFindFa && (
          <ConnectFA showCaFindFa={showCaFindFa} />
        )}
      </div>
    </>
  );
};

DownloadSendConnect.propTypes = {
  downloadingPdf: PropTypes.bool.isRequired,
  showFindFa: PropTypes.bool.isRequired,
  showCaFindFa: PropTypes.bool,
  showSendToFa: PropTypes.bool.isRequired,
  sendingPdfToFa: PropTypes.bool.isRequired,
  sendResultsButtonDisabled: PropTypes.bool.isRequired,
  setSendingPdfToFa: PropTypes.func.isRequired,
  setDownloadingPdf: PropTypes.func.isRequired,
  setResultsSentToFa: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  resultsToSendToDelegator: PropTypes.object.isRequired,
  setNotificationContent: PropTypes.func.isRequired,
  setNotificationOpen: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  query: PropTypes.object.isRequired,
  sessionId: PropTypes.string.isRequired,
  coldContactData: PropTypes.objectOf(PropTypes.string),
  setColdContactData: PropTypes.func.isRequired,
  faInfo: PropTypes.objectOf(PropTypes.string).isRequired,
  contactName: PropTypes.objectOf(PropTypes.string),
  userComments: PropTypes.string,
  setUserComments: PropTypes.func.isRequired,
};
DownloadSendConnect.defaultProps = {
  coldContactData: {},
  contactName: {},
  userComments: '',
  showCaFindFa: false,
};
export default DownloadSendConnect;
